import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=000d13e0&scoped=true&"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js&"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenLoader.vue?vue&type=style&index=0&id=000d13e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000d13e0",
  null
  
)

export default component.exports